{
  "Use AirPlay": "Utiliser AirPlay"
}
